import { render, staticRenderFns } from "./ContextModalNew.vue?vue&type=template&id=5112bde8&scoped=true&"
import script from "./ContextModalNew.vue?vue&type=script&lang=js&"
export * from "./ContextModalNew.vue?vue&type=script&lang=js&"
import style0 from "./ContextModalNew.vue?vue&type=style&index=0&id=5112bde8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5112bde8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDialog,VRow,VTooltip})
